<div class="brokerage-note-component">
  <div class="row header" #header>
    <div class="col-10 align-items-header-modal">
      <mat-icon class="icon-order" svgIcon="file"></mat-icon>
      <span class="title">{{ title }}</span>
    </div>
    <div class="col-2 txt-right">
      <mat-icon class="icon-close-btn pointer" (click)="close()" svgIcon="close-btn"></mat-icon>
    </div>
  </div>
  <div class="filter">
    <div class="row network-error-message-oms" *ngIf="!statusOmsOnline">{{ msgStatusOmsOffile }}</div>
    <div class="d-flex box-radio-button-group">
      <mat-radio-group id="radio-group-list" class="option-radio" *ngFor="let radio of radioButtonList"
        [(ngModel)]="selectRadio">
        <mat-radio-button id="radio-button-{{radio.desc}}" class="radio-button mr-1" [value]="radio.id"
          (click)="changeTypeRadio(radio)">
          {{ radio.desc }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="row row-filter">
      <div *ngIf="selectRadio === brokerageNoteTypeEnum.SPECIFIC_DATE" class="col-3 col-datepicker">
        <mat-form-field class="date">
          <input appDatepickerMask matInput [matDatepicker]="picker2" placeholder="Data" [(ngModel)]="dataFilter"
            maxlength="10">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
      <div *ngIf="selectRadio === brokerageNoteTypeEnum.MY_NOTE" class="col-5 col-datepicker-range">
        <span class="label">selecione o período desejado</span>
        <ngbd-datepicker-range [maxDateToday]='true' id="datepicker" class="modal-datepicker" [reset]="changingValue"
          [startEmpty]='false' [minOneYear]="true" (dateIni)="changeDateIni($event)" (dateFin)="changeDateFim($event)">
        </ngbd-datepicker-range>
      </div>
      <div class="col-3 col-agency">
        <mat-form-field>
          <mat-select placeholder="Mercado" [(ngModel)]="market">
            <mat-option *ngFor="let item of listMarket" value="{{item.value}}">{{item.desc}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-2 col-btn-filter">
        <button mat-raised-button class="xs white" (click)="fetchNote(selectRadio)"
          [disabled]="(selectRadio === 0 && !market) || ((selectRadio === 1 || selectRadio === 2) && (!dataFilter || !market))">
          Buscar
        </button>
      </div>
      <div class="col-2 col-btn-filter" *ngIf="urlPdf">
        <button mat-raised-button class="xs white" (click)="clearNote()">Limpar</button>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="spinner-get">
    <app-spinner-loading></app-spinner-loading>
  </div>
  <div *ngIf="(showNote) && !loading" class="pdf">
    <object *ngIf="urlPdf" [data]="urlPdf" type="application/pdf"></object>
  </div>
  <div *ngIf="selectRadio === brokerageNoteTypeEnum.MY_NOTE && !loading">
    <div>
      <table *ngIf="!showNote && dateList.length > 0" class="table-orders w-100" id="table-orders">
        <tbody>
          <ng-template class="row-template" ngFor let-item [ngForOf]="dateList" let-i="index">
            <tr class="table-row-height" id="tr{{i}}">
              <td><span class="pl-3 cursor-default">{{item}}</span></td>
              <td>
                <mat-icon (click)="viewNote(item)" svgIcon="visibility"></mat-icon>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="!showNote && dateList.length === 0 && !loading && wasBrokerageFetched" class="empty">
    <app-empty-result></app-empty-result>
  </div>
</div>